export const manuscriptGuidelines = [
    {
        intro: "Manuscripts must be neatly typed (size page A4), I 3 format (except Arts), single spaced throughout, including figures and tables, with at least 2 cm margins on all sides. The manuscript should encompass only a maximum of 8- 10 pages with less than 10% plagiarized content checked through Drill Bit software. The Editor reserves the right to adjust style to certain standards of uniformity. The authors are requested to frame manuscript in the following order:",
        points: [
            {
                category: "Title:",
                description: " should appear as inverted pyramid, clear, descriptive and unambiguously reflect the paper's contents and must be devoid of symbols and abbreviations."
            },
            {
                category: "Name(s) of author(s):",
                description: " first name, initial(s) of the middle name(s), and family name of each author. The corresponding author should be identified with an asterisk (*)."
            },
            {
                category: "Affiliations:",
                description: " include the name of department (if any), institution, city and state or country where the work was done, indicating which authors are associated with which affiliation."
            },
            {
                category: "Email address of the corresponding author,",
                description: " as all correspondence, including proofs, will be send only to him/her."
            },
            {
                category: "Abstract:",
                description: " not exceeding 100 words, reporting concisely on the major findings. This section should be unique in its own right."
            },
            {
                category: "Key Words:",
                description: " at least three and not more than six in alphabetical order can be listed."
            },
            {
                category: "All main headings:",
                description: " of the content must be notified in bold with first letter alone capitalized starting from the margin while subheadings need to be underlined with one tab space from the margin."
            },
            {
                category: "Introduction:",
                description: " should be brief with important prior publications and mention the reasons for the investigation being reported. Each new paragraph must be assigned with a suitable subheading. Introduction must be followed by description of methods, equipment and techniques applied (including statistical treatments used in the research)."
            },
            {
                category: "Results:",
                description: " Present the findings of the study as clearly and concisely as possible. Tables and other representations must be descriptive, meaningful with all of its parts being included."
            },
            {
                category: "Discussion:",
                description: " (may be combined with the Results section)."
            },
            {
                category: "Conclusions:",
                description: " must be genuine conclusions drawn from the results of the study."
            },
            {
                category: "Future Scope:",
                description: " The possibility of continuity of work in the future should be clearly presented."
            },
            {
                category: "Acknowledgements:",
                description: " and any additional information concerning research grants, etc can be mentioned."
            },
            {
                category: "References:",
                description: " The final reference list should include full descriptions of only those sources that are cited in the text in alphabetical order.(to be followed by all streams)"
            },
            {
                category: " For SCIENCE PAPERS alone:",
                description: " Standard numbered style has to be followed throughout text and the final reference list should be as similar to the above mentioned."
            },

        ]
    }
];

export const referenceFormat = [
    {
        category: "Reference format for all streams",
        points: [
            {
                title: "Journal Article with Single Author: ",
                description: " Waldron, S 2008, ‘Generalized Welch bound equality sequences are tight frames’, IEEE Transactions on Information Theory, vol. 49, no. 9, pp. 2307-2309."
            },

            {
                title: "Journal Article with Two Authors:",
                description: " Conley, TG &amp; Galeson, DW 1998, ‘Nativity and wealth in mid-nineteenth century cities’, Journal of Economic History, vol. 58, no. 2, pp. 468-493."
            },
            {
                title: "Journal Article with more than two Authors: ",
                description: " Alishahi, K, Marvasti, F, Aref, VA & Pad, P 2009, ‘Bounds on the sum capacity of synchronous binary CDMA channels’, Journal of Chemical Education, vol. 55, no. 8, pp. 3577-3593."
            },
            {
                title: "Books: ",
                description: " Holt, DH 1997, Management Principles and Practices, Prentice-Hall, Sydney E-book: Aghion, P &amp; Durlauf, S (eds.) 2005, Handbook of Economic Growth, Elsevier, Amsterdam. Available from: Elsevier books. [4 November 2004]."
            },
            {
                title: "Conference Proceeding Paper with editors: ",
                description: " Riley, D 1992, ‘Industrial relations in Australian education’, in Contemporary Australasian industrial relations: proceedings of the sixth AIRAANZ conference, ed. D. Blackmur, AIRAANZ, Sydney, pp. 124-140."
            },
            {
                title: "Conference Proceeding Paper without editors: ",
                description: " Fan, W, Gordon, MD &amp; Pathak, R 2000, ‘Personalization of search engine services for effective retrieval and knowledge management’, Proceedings of the twenty-first international conference on information systems, pp. 20-34."
            },
            {
                title: "Website: ",
                description: " Australian Securities Exchange 2009, Market Information. Available from:. [5July 2009]."
            },
            {
                title: "Thesis: ",
                description: " Unpublished Hos, JP 2005, Mechanochemically synthesized nanomaterials for intermediate temperature solid oxide fuel cell membranes. Ph.D. thesis, University of Western Australia."
            },
            {
                title: "Newspaper: ",
                description: " Print Ionesco, J 2001, 'Federal election: new Chip in politics', The Advertiser 23 October, p. 10."
            }
        ]
    }
];

